import { useAuth0 } from "@auth0/auth0-react";
import dateIcon from "assets/icons/date-picker.svg";
import { LabelField, MyCheckbox } from "components";
import { MenuMultiCheckBox } from "components/MenuMultiCheckBox/MenuMultiCheckBox";
import Loader from "components/loader/Loader";
import { useFormik } from "formik";
import { debounce, filter } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { toastr } from "react-redux-toastr";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import FinanceService from "../../../Lib/API/Finance";
import { DateFormetContext } from "../../../app/App.js";
import Download from "../../../assets/icons/Download.svg";
import Share from "../../../assets/icons/Share.svg";
import Eye from "../../../assets/icons/eyeIcon.svg";
import SuccessIcon from "../../../assets/icons/successStatement.svg";
import MyButton from "../../../components/MyButton";
import SearchDownShift from "../../../components/downmshift/DownShift";
import "../NewTaxStatement/styles.scss";
import { TextAreaMessage } from "../Theme";

const NewTaxReport = ({
  onSearchChange,
  documentData,
  documentType,
  downloadPDF,
  sharePDF,
  closeModal,
  viewDocumentHandler,
  downloadFileHandler,
  documentHandler
}) => {
  const dateFormet = React.useContext(DateFormetContext);
  const [search, setSearch] = useState("");
  const [id, setId] = useState("");
  const [startDate, setStartDate] = useState(`${new Date()?.getFullYear()}-01-01`);
  const [endDate, setEndDate] = useState(`${new Date()?.getFullYear()}-12-31`);
  const [data, setData] = useState("");
  const [docData, setDocData] = useState([]);
  const [isSuccess, setIsSucess] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [calendar, setCalender] = useState(false);
  const [calendarEnd, setCalenderEnd] = useState(false);
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe("mm/dd/yyyy");
  const [loading, setLoading] = useState(false);
  const [ledgers, setLedgers] = useState([]);
  const [isLedgerLoading, setIsLedgerLoading] = useState(false);
  const [year, setYear] = useState(new Date());



  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: {
      all_ledger_sub_data: [],
      selectAllLedger: false,
      selectAllSubLedger: false,
      taxOverride: false,
      addNote: false,
      note: "",
    },
    validationSchema: "",
    onSubmit: async (values) => { },
  });
  useEffect(() => {
    setIsLedgerLoading(true);
    async function getLedgeraccounts() {
      const token = await getAccessTokenSilently();
      const res = await FinanceService.getLedgerSubLedgerListAll(token);
      if (res?.ledgers) {
        const arrayWithSelectAll = ["Select All", ...res?.ledgers];
        setLedgers(arrayWithSelectAll);
      }
      setIsLedgerLoading(false);
    }
    getLedgeraccounts();
  }, [getAccessTokenSilently]);

  const fetchAccounts = async () => {
    // enableLoading(true);
    const token = await getAccessTokenSilently();
    await FinanceService.getACcountNames(token, search, true)
      .then((res) => {
        if (res?.accounts) {
          const option2 =
            res.accounts &&
            res.accounts?.map((item, index) => ({
              id: item?._id,
              name: item?.family_name,
            }));

          setData(option2);
        }
        // enableLoading(false);
      })
      .catch((error) => {
        toastr.error(error?.data?.message);
      });
  };
  useEffect(() => {
    fetchAccounts();
  }, [search]);

  useEffect(() => {
    if (startDate === null && endDate !== null) {
      setEndDate(null);
      setStartDate(null);
    }

    if (startDate > endDate && startDate !== null && endDate !== null) {
      setEndDate(null);
      setStartDate(null);
    }

  }, [startDate, endDate])


  const getAllSelectedLedger = () => {
    const { all_ledger_sub_data } = formik?.values || {};

    if (!all_ledger_sub_data || !all_ledger_sub_data?.length) return { allLedgerIds: [], allSubLedgerIds: [] };

    const allLedgerIds = [];
    const allSubLedgerIds = [];

    all_ledger_sub_data.forEach(({ type, id }) => {
      if (type === "ledger") {
        allLedgerIds.push(id);
      } else if (type === "sub_ledger") {
        allSubLedgerIds.push(id);
      }
    });

    return {
      allLedgerIds,
      allSubLedgerIds,
    };
  };

  const fetchMyAPI = async (e) => {
    setLoading(true);
    const { allLedgerIds } = getAllSelectedLedger();
    const token = await getAccessTokenSilently();
    const body = {
      account: {
        id: id,
        name: search,
      },
      start: moment(startDate).format("MM/DD/YYYY"),
      end: moment(endDate).format("MM/DD/YYYY"),
      ledger: formik?.values?.selectAllLedger ? allLedgerIds : formik?.values?.ledger || [],
      subLedger: (formik?.values?.selectAllLedger && formik?.values?.selectAllSubLedger) ? [] : formik?.values?.subLedger || [],
      taxOverride: formik?.values?.taxOverride,
      note: formik?.values?.addNote ? formik?.values?.note : undefined,
    };

    await FinanceService.createNewTaxReport(body, token)
      .then((res) => {
        const result = res;
        documentData(result.result);
        setDocData(result.result);
        setIsSucess(!isSuccess);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toastr.error(error?.data?.message);
      });
  };

  const create = () => {
    if (year && search !== "" && id !== "" && (formik.values?.addNote ? formik.values?.note : true)) {
      fetchMyAPI();
    } else {
      toastr.error("Error", "Please Fill all the fields");
    }

    window.addEventListener("save-transaction", fetchMyAPI);
    return () => {
      window.removeEventListener("save-transaction", fetchMyAPI);
    };
  };

  const handelView = () => {
    documentType(docData.type);
  };
  const handelDelete = () => {
    documentData(docData);
    downloadPDF(docData.type);
  };

  const HandleShare = () => {
    sharePDF("tax_report");
  };

  const handleYear = (date) => {
    setYear(date)
    if (date) {
      setStartDate(`${date?.getFullYear()}-01-01`);
      setEndDate(`${date?.getFullYear()}-12-31`);
    } else {
      setStartDate(null);
      setEndDate(null);
    }

  }

  return data ? (
    <div className="NewTaxStatement px-10 d-flex flex-column justify-content-center">
      {isSuccess !== true ? (
        <>
          <h1 className="heading text-center font-weight-bolder font-20">
            Tax Report
          </h1>
          <div className="mt-10 search">
            <p>Account Name</p>
            {data ? (
              <SearchDownShift
                items={data ? data : null}
                name={search}
                setName={setSearch}
                setId={setId}
                placeHolder="Search"
                autoFocus
              />
            ) : null}
          </div>
          <div
            className="d-flex justify-content-between mt-20"
          >

            <div className="w-50">
              <LabelField title={"Exclude transactions from selected ledgers"} mandatory={false} />
              <MenuMultiCheckBox
                Items={ledgers}
                formik={formik}
                loading={isLedgerLoading}
                isLedger={true}
                withBorder={true}
                field="all_ledger_sub_data"
              />
            </div>
            <div
              className="w-50"
              style={{
                marginRight: "6rem",
              }}
            >
              <LabelField title={"Year selection"} mandatory={true} />
              <div className="date-wrapper docu-date year-selection ">
                <DatePicker
                  mandatory
                  selected={year}
                  onChange={(date) => handleYear(date)}
                  showYearPicker
                  dateFormat="yyyy"
                  minDate={new Date().setFullYear(new Date().getFullYear() - 11)}
                  maxDate={new Date()}
                />
              </div>
            </div>

          </div>
          <div className="mt-10">
            <MyCheckbox
              title="Recalculate tax details using updated ledger data"
              checked={formik.values.taxOverride}
              onChange={() => formik.setFieldValue('taxOverride', !formik.values.taxOverride)}
            />
          </div>
          <div className="mt-10">
            <div>

              <div
                className="w-50 mt-5"
              >
                <MyCheckbox
                  title="Add note"
                  checked={formik.values.addNote}
                  onChange={(e) => {
                    const { checked } = e.target;
                    formik.setFieldValue('addNote', checked);
                  }}
                />
              </div>
              {formik.values?.addNote && (
                <div
                  className="mt-5"
                >
                  <LabelField
                    title={"Note"}
                    mandatory={true}
                  />
                  <TextAreaMessage
                    aria-label="empty textarea"
                    minRows={12}
                    placeholder="Note"
                    value={formik.values?.note}
                    onChange={(e) => {
                      formik.setFieldValue('note', e.target.value);
                    }}
                  />
                </div>
              )}
            </div>

          </div>

          <div className="d-flex justify-content-center mt-10 btn">
            <MyButton
              buttonTextStyle={{ margin: 0, paddingBlock: 4.3 }}
              type={"primary"}
              disabled={loading}
              content={"Create"}
              onClick={create}
            />
          </div>
        </>
      ) : (
        <>
          <div className="d-flex align-items-center">
            <img src={SuccessIcon} className="mr-2" />
            <p className="m-0 font-weight-bolder ">
              Tax Report successfully created{" "}
            </p>
          </div>
          <div className=" d-flex justify-content-around h-50 align-items-center">
            <div>
              <a className="link" onClick={() => {
                viewDocumentHandler(docData?._id)
              }}>
                <img src={Eye} className="mr-2" />
                View
              </a>
            </div>

            <div style={{ cursor: "pointer" }} onClick={() => {
              downloadFileHandler(docData)
            }}>
              <a className="link">
                <img src={Download} className="mr-2" />
                Download
              </a>
            </div>

            <div>
              <a className="link"
                onClick={() => {
                  documentHandler(docData)
                }}
              >
                <img src={Share} className="mr-2" />
                Share
              </a>
            </div>
          </div>
          <div className="d-flex justify-content-center mt-10 closeBtn">
            <MyButton
              buttonTextStyle={{ margin: 0, paddingBlock: 4.3 }}
              type={"primary"}
              content={"Close"}
              onClick={closeModal}
            />
          </div>
        </>
      )}
    </div>
  ) : (
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
      <Loader />
    </div>
  );
};
export default NewTaxReport;
